import React,{useState,useContext} from "react";
import axios from "axios";
import { SAVE_FREE_RIDE_URL,GET_FREE_RIDE_URL } from "../Utils/URLs";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
const FreeRideState = ()=>{
    const [progress,setProgress] = useState(0)
const [formBusy,setFormBusy] = useState(false)
const [response,setResponse] = useState("")
const [freeRideData,setFreeRideData] = useState([])
const navigate = useNavigate()
const token = localStorage.getItem("token")
const {setNotifications} = useContext(UserContext)

const SaveFreeRide = async(data)=>{
    
    try{
        setFormBusy(true)
        await axios.post(SAVE_FREE_RIDE_URL,data,{
            onUploadProgress:(ProgressEvent)=>{
             const { loaded, total } = ProgressEvent;
     
                     const progressState = Math.round((loaded / total) * 100);
                     setProgress(progressState)
                     localStorage.setItem("progress",progressState)
                    
            }     
             }).then((res)=>{
            console.log(res)
            setResponse(res.data)
        })
        setFormBusy(false)
    }catch(error){
        console.log(error)
        setFormBusy(false)
    }
}

const GetFreeRide = async () => {
    try {
       
        await axios.get(GET_FREE_RIDE_URL,{headers:{
            Authorization:`Bearer ${token}`
        }}).then((res) => {
           
            setFreeRideData(res.data.response)
            if (res.data.notification.length !== 0) {
                res.data.notification.forEach((item) => {
                    setNotifications((prev) => {
                        if (prev) {
                            const exist = prev.find((e) => e._id === item._id);
                            
                            if (!exist) {
                                return [...prev, item];
                            }
                        } else {
                            return [item];
                        }
                        return prev;
                    });
                });
            }
        })
        
    } catch (error) {
        console.log(error)
        if(error.response.data.msg==="token_error"){
          
            localStorage.clear()
            navigate("/driver_forms/login")
          }
    }
}


return {
    SaveFreeRide,
    formBusy,
    response,
    progress,
    GetFreeRide,
    freeRideData
}
}

export default FreeRideState